<template>
  <div class="m-shipping-methods-warehouse-pickup">
    <div class="row pb-6">
      <div class="col-12 text-xsmall">
        {{ $t('pickUpText', 'pickUpText') }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6 align-self-baseline">
        <div class="bold">
          Oluf Brønnum &amp; Co
        </div>
        <div class="text-small">
          {{ address }}
        </div>
        <div class="text-small">
          {{ postalCode }} {{ city }}
        </div>
      </div>
      <div class="col-12 col-sm-6 no-gutters">
        <div
          v-for="(openingHour, index) in internalOpeningHours"
          :key="index"
          class="row col-12 no-gutters"
        >
          <div class="col-12 col-sm-6 no-gutters">
            <span class="text-small">
              {{ openingHour.daysText }}
            </span>
          </div>
          <div class="col-12 col-sm-6 no-gutters text-right">
            <span class="text-small">
              {{ openingHour.hoursText }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="m-shipping-methods-warehouse-pickup__map-container">
      <client-only>
        <l-map
          :zoom="7"
          :center="[56.165165,10.181264]"
          @ready="onMapReady"
        >
          <l-tile-layer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" />
          <l-marker :lat-lng="internalCoordinates" />
        </l-map>
      </client-only>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShippingMethodsWarehousePickup',
  props: {
    value: {
      type: Object,
      required: true
    },
    address: {
      type: String,
      default: ''
    },
    postalCode: {
      type: String,
      default: ''
    },
    city: {
      type: String,
      default: ''
    },
    openingHours: {
      type: Array,
      default: () => []
    },
    coordinates: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      dropPoint: '',
      map: null,
    }
  },
  computed: {
    internalCoordinates () {
      return this.coordinates.split(',');
    },
    internalOpeningHours () {
      return this.openingHours.map((openingHourString) => {
        const separatorIndex = openingHourString.indexOf(' ');

        return {
          daysText: openingHourString.slice(0, separatorIndex),
          hoursText: openingHourString.slice(separatorIndex + 1),
        };
      });
    }
  },
  created () {
    this.$emit('input', {
      ...this.value,
      address: this.address,
      zipCode: this.postalCode,
      city: this.city,
    });
    this.$emit('update-shipping-address');
  },
  methods: {
    onMapReady (map) {
      this.map = map;
      this.fitBounds();
    },
    fitBounds () {
      this.map.fitBounds([this.internalCoordinates], {
        padding: [50, 50]
      });
    },
  }
}
</script>
